import { io, Socket } from "socket.io-client";
import { baseApiURL } from "./baseApiUrl";
import { getRawToken, getToken } from "../utils/tokenFunctions";
function resolveToken(): string | null {
  let token = getToken();
  if (!token) {
    console.warn("[socketClient] No se encontró access token, intentando raw token (LTI mode)...");
    token = getRawToken();
  }
  if (!token) {
    console.error("[socketClient] No existe token válido para iniciar conexión WebSocket.");
    return null;
  }
  return `Bearer ${token}`;
}
// Obtener token antes de crear la conexión
const authToken = resolveToken();
// Evita inicializar socket sin token válido y con baseApiURL definido
export const socket: Socket | null =
  authToken && baseApiURL
    ? io(baseApiURL, {
        transports: ["websocket"],
        autoConnect: false,
        auth: { token: authToken },
      })
    : null;
//log de estado
if (!authToken || !baseApiURL) {
  if (!authToken) {
    console.warn("[socketClient] Socket no inicializado: falta token de autenticación.");
  }
  if (!baseApiURL) {
    console.warn("[socketClient] Socket no inicializado: falta baseApiURL para la conexión.");
  }
} else {
  console.info("[socketClient] Socket configurado correctamente para conexión segura.");
}